import React from 'react';
import { Box, BoxProps } from '@mui/material';
import logoPrimary from '../assets/logos/logo-primary.svg';
import logoWhite from '../assets/logos/logo-white.svg';
import { useAuth } from '../contexts/AuthContext';

interface LogoProps extends Omit<BoxProps, 'component'> {
  variant?: 'primary' | 'white';
  height?: number | string;
  width?: number | string;
  alt?: string;
  ignoreUserLogo?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  variant = 'primary', 
  height = 'auto', 
  width = 'auto',
  alt = 'BLOBTIC Logo',
  ignoreUserLogo = false,
  sx,
  ...props 
}) => {
  const { user } = useAuth();
  const defaultLogoSrc = variant === 'white' ? logoWhite : logoPrimary;
  const logoSrc = (!ignoreUserLogo && user?.dosLogo) ? user.dosLogo : defaultLogoSrc;

  return (
    <Box
      component="img"
      src={logoSrc}
      alt={alt}
      sx={{
        height,
        width,
        display: 'block',
        objectFit: 'contain',
        ...sx
      }}
      {...props}
    />
  );
};

export default Logo;
